module.exports = __webpack_public_path__ + "static/sat-7807125b34876a5c7d0b89e95a792d9d.jpg";